import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- entities
import ProductOption from 'PMT/entities/menu/ProductOption';

// -- views

class ProductOptionRow extends Component {

  static propTypes = {
    productOption: PropTypes.instanceOf(ProductOption).isRequired
  };


  shouldComponentUpdate(nextProps) {
    return !nextProps.productOption.equals(this.props.productOption);
  }

  onDisplayDetail = () => {
    RouteAction.presentProductOptionDetail(this.props.productOption);
  };

  onUp = () => {

  };

  onDown = () => {

  };

  render() {
    const productOption:ProductOption = this.props.productOption;

    return (
      <tr className="option_row pointer">

        <td className="option__name" onClick={this.onDisplayDetail}>
          {productOption.name}
        </td>

        <td
          className="pointer col-md-1 text-center"
        >
        </td>

        <td
          className="pointer col-md-1 text-center"
        >
        </td>
      </tr>
    );
  }

}

export default ProductOptionRow;
